module.exports = __webpack_public_path__ + "img/DE00639.fbac184e.png";